import React from 'react'
import Hero from './Sections/Hero/Hero'
import Subservices from './Sections/Subservices/Subservices'
import AppComparison from './Sections/AppComparison/AppComparison'
import CaseStudies from '../../Home/Components/CaseStudies'
import ProcessSection from './Sections/ProcessSection/ProcessSection'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import Footer from '../../../Components/Footer/Footer'
import Navigation from '../../../Components/Navigation/Navigation'
import aiImage from '../../../assets/images/ai_ml.png'
import Industries from './Sections/Industries/Industries'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'

const AIML = () => {
    const homeContent = {
        title: "Unlock Business Intelligence with Advanced AI Solutions",
        description: "Harness the power of artificial intelligence with KoolMind's specialized AI development team, creating intelligent systems that automate processes and drive innovation! Leading AI implementation across Singapore, Malaysia, Thailand & India.",
        image: aiImage,
        breadcrumb: "AI & ML",
        d1: "Ready to Automate Your Future?",
        d2: "Connect with AI specialists who transform complex data into actionable insights!",
        b: "Explore AI Solutions"
    }
  
    const subservicesTitles ={
        header: "We develop intelligent systems that revolutionize how businesses operate and make decisions.",
        subservices: [
            {
                iconFileName: "s15.svg",
                title: "Intelligent Process Automation",
                subtitle: ""
            },
            {
                iconFileName: "s22.svg",
                title: "Predictive Analytics Platforms",
                subtitle: ""
            },
            {
                iconFileName: "s16.svg",
                title: "Computer Vision Applications",
                subtitle: ""
            },
            {
                iconFileName: "s17.svg",
                title: "Natural Language Understanding",
                subtitle: ""
            },
            {
                iconFileName: "s18.svg",
                title: "Recommendation Engine Development",
                subtitle: ""
            },
            {
                iconFileName: "s19.svg",
                title: "Fraud Detection Systems",
                subtitle: ""
            },
            {
                iconFileName: "s20.svg",
                title: "Smart Document Processing",
                subtitle: ""
            },
            {
                iconFileName: "s21.svg",
                title: "Conversational AI Development",
                subtitle: ""
            }
        ]
    }

    const compareHeader = {
        title: "Difference between Supervised Learning & Unsupervised Learning",
        description: "Learn which AI approach delivers accurate predictions, uncovers hidden patterns, and provides the most value for your specific business challenges!"
    }

    const diff1 = {
        title: "Supervised machine learning",
        features: [
            { text: "Trained with labeled datasets" },
            { text: "Produces highly accurate predictions" },
            { text: "Excellent for classification tasks" },
            { text: "Measurable performance metrics" },
            { text: "Clear validation processes" },
            { text: "Predictable output generation" },
            { text: "Ideal for business forecasting" },
            { text: "Requires quality training data" },
            { text: "Proven algorithmic approaches" },
            { text: "Delivers consistent reliable results" }
        ]
    }

    const diff2 = {
        title: "Unsupervised machine learning",
        features: [
            { text: "Discovers hidden data patterns" },
            { text: "Explores unknown relationships automatically" },
            { text: "Requires no pre-labeled information" },
            { text: "Uncovers unexpected business insights" },
            { text: "Challenging performance evaluation" },
            { text: "Exploratory data analysis strength" },
            { text: "Perfect for market segmentation" },
            { text: "Handles complex data structures" },
            { text: "Generates novel business hypotheses" },
            { text: "Provides innovative analytical perspectives" }
        ]
    }

    const processSection = {
        title: "AI Implementation",
        description: "Fortune 500 companies rely on KoolMind's AI expertise to stay competitive. Our methodology combines cutting-edge research with practical business applications. This proven 6-stage approach ensures AI solutions deliver measurable ROI and sustainable competitive advantages.",
        steps: [
            {
                title: "Data Assessment",
                description: "Our experts evaluate data quality and identify optimal AI implementation opportunities.",
                icon: "s12.svg"
            },
            {
                title: "Model Selection",
                description: "We choose appropriate algorithms and design custom AI architectures for requirements.",
                icon: "s13.svg"
            },
            {
                title: "Training & Development",
                description: "Machine learning engineers develop and train sophisticated models using advanced techniques.",
                icon: "s14.svg"
            },
            {
                title: "Integration Planning",
                description: "We seamlessly integrate AI capabilities into existing business workflows and systems.",
                icon: "s15.svg"
            },
            {
                title: "Performance Optimization",
                description: "Continuous model refinement and performance tuning ensure optimal accuracy levels.",
                icon: "s16.svg"
            },
            {
                title: "Monitoring & Evolution",
                description: "Real-time model monitoring and adaptive improvements maintain peak AI performance.",
                icon: "s17.svg"
            }
        ]
    }

    return (
        <div>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <Subservices subservicesTitles={subservicesTitles} />
            <AppComparison compareHeader={compareHeader} diff1={diff1} diff2={diff2} />
            <ProcessSection processSection={processSection} />
            <CaseStudies />
            <Industries />
            <ClientSpeak />
            <GetQuote />
            <Contect />
            <Footer />
        </div>
    )
}

export default AIML
